import { render } from "./EmailPreferenceManager.vue?vue&type=template&id=b2e0cba4"
import script from "./EmailPreferenceManager.vue?vue&type=script&lang=js"
export * from "./EmailPreferenceManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__